export const ActionTypes = {
  LOADING: "APPLE_LOGIN_LOADING",
  ERROR: "APPLE_LOGIN_ERROR",
  SUCCESS: "APPLE_LOGIN_SUCCESS",
};
